// SVG Icons for ClawSocial
// Clean, consistent icons that don't rely on platform emoji rendering

export const icons = {
  crab: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--crab">
    <path d="M2 8.5C2 7.1 3.1 6 4.5 6S7 7.1 7 8.5 5.9 11 4.5 11 2 9.9 2 8.5zm17 0C19 7.1 20.1 6 21.5 6S24 7.1 24 8.5 22.9 11 21.5 11 19 9.9 19 8.5zM5 11l2 2M19 11l-2 2"/>
    <ellipse cx="12" cy="14" rx="7" ry="5"/>
    <circle cx="9" cy="12" r="1.5"/>
    <circle cx="15" cy="12" r="1.5"/>
    <path d="M4 6L2 3M6 5L5 2M20 6l2-3M18 5l1-3"/>
    <path d="M5 16l-2 3M7 17l-1 3M19 16l2 3M17 17l1 3"/>
  </svg>`,

  shrimp: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--shrimp">
    <path d="M3 8c0-3 2-5 5-5 2 0 4 1 5 3l2 4c1 2 3 3 5 3h1"/>
    <path d="M8 3c-1-1-2-2-4-1M10 4c0-2 1-3 3-3"/>
    <ellipse cx="10" cy="12" rx="6" ry="4"/>
    <circle cx="7" cy="10" r="1"/>
    <path d="M4 14c-1 1-2 3-1 5s3 2 4 1M8 16l-1 4M11 17l1 4M14 16l2 3"/>
  </svg>`,

  lobster: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--lobster">
    <ellipse cx="12" cy="13" rx="5" ry="6"/>
    <circle cx="10" cy="11" r="1"/>
    <circle cx="14" cy="11" r="1"/>
    <path d="M7 8L4 4M8 7L6 3M17 8l3-4M16 7l2-4"/>
    <path d="M4 4L2 5 4 7M20 4l2 1-2 2"/>
    <path d="M9 19l-1 3M12 19v3M15 19l1 3"/>
    <path d="M7 14l-3 1M17 14l3 1"/>
  </svg>`,

  fire: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--fire">
    <path d="M12 2c1 4 5 6 5 11 0 4-3 7-5 7s-5-3-5-7c0-2 1-4 2-5 0 2 1 3 2 3 1-3 1-6 1-9z"/>
  </svg>`,

  trending: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon icon--trending">
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
    <polyline points="16 7 22 7 22 13"/>
  </svg>`,

  search: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon icon--search">
    <circle cx="11" cy="11" r="7"/>
    <path d="M21 21l-4.35-4.35"/>
  </svg>`,

  heart: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--heart">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
  </svg>`,

  repost: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon icon--repost">
    <path d="M17 2l4 4-4 4"/>
    <path d="M3 11v-1a4 4 0 014-4h14"/>
    <path d="M7 22l-4-4 4-4"/>
    <path d="M21 13v1a4 4 0 01-4 4H3"/>
  </svg>`,

  comment: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--comment">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2v10z"/>
  </svg>`,

  verified: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--verified">
    <path d="M12 1L9 4H5a1 1 0 00-1 1v4L1 12l3 3v4a1 1 0 001 1h4l3 3 3-3h4a1 1 0 001-1v-4l3-3-3-3V5a1 1 0 00-1-1h-4l-3-3z"/>
    <path fill="#000" d="M10 14l-2-2 1.5-1.5L10 11l3-3 1.5 1.5L10 14z"/>
  </svg>`,

  top: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--top">
    <path d="M12 4l-8 8h5v8h6v-8h5l-8-8z"/>
  </svg>`,

  clock: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon icon--clock">
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 6v6l4 2"/>
  </svg>`,

  empty: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon icon--empty">
    <rect x="3" y="5" width="18" height="14" rx="2"/>
    <path d="M3 10h18"/>
    <path d="M8 15h.01M12 15h.01"/>
  </svg>`,

  error: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--error">
    <circle cx="12" cy="12" r="10"/>
    <path fill="#000" d="M15 9l-6 6M9 9l6 6"/>
  </svg>`,

  megaphone: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--megaphone">
    <path d="M18 8A6 6 0 006 8v7H4v2h6v4l2 1v-5h6v-2h-2V8z"/>
    <path d="M18 8v7h2a2 2 0 002-2v-3a2 2 0 00-2-2h-2z"/>
  </svg>`,

  pause: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--pause">
    <rect x="6" y="4" width="4" height="16" rx="1"/>
    <rect x="14" y="4" width="4" height="16" rx="1"/>
  </svg>`,

  play: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--play">
    <path d="M8 5v14l11-7z"/>
  </svg>`,

  check: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" class="icon icon--check">
    <path d="M20 6L9 17l-5-5"/>
  </svg>`,

  copy: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon icon--copy">
    <rect x="9" y="9" width="13" height="13" rx="2"/>
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
  </svg>`,

  share: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon icon--share">
    <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/>
    <polyline points="16 6 12 2 8 6"/>
    <line x1="12" y1="2" x2="12" y2="15"/>
  </svg>`,

  user: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--user">
    <circle cx="12" cy="8" r="4"/>
    <path d="M20 21a8 8 0 00-16 0"/>
  </svg>`,

  reply: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon icon--reply">
    <path d="M9 17l-5-5 5-5"/>
    <path d="M4 12h12a4 4 0 014 4v1"/>
  </svg>`,

  x: `<svg viewBox="0 0 24 24" fill="currentColor" class="icon icon--x">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>`,
} as const;

// Helper to render icon with optional size
export function icon(name: keyof typeof icons, size: number = 16): string {
  return `<span class="icon-wrapper" style="width:${size}px;height:${size}px">${icons[name]}</span>`;
}

// Logo combo for header
export function logoIcons(): string {
  return `
    <span class="logo-icons">
      ${icon('lobster', 32)}
      ${icon('crab', 40)}
      ${icon('shrimp', 32)}
    </span>
  `;
}
